/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code point is the character's number in the Unicode standard (e.g. U+00E9 for é). UTF-8 bytes are how that code point is stored — é is two bytes, C3 A9.`)
};

const es_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El punto de código es el número del carácter en el estándar Unicode (por ej. U+00E9 para é). Los bytes UTF-8 son cómo se almacena ese punto de código: é son dos bytes, C3 A9.`)
};

const de_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Codepunkt ist die Nummer des Zeichens im Unicode-Standard (z. B. U+00E9 für é). UTF-8-Bytes geben an, wie dieser Codepunkt gespeichert wird — é sind zwei Bytes, C3 A9.`)
};

const nl_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het codepunt is het nummer van het karakter in de Unicode-standaard (bijv. U+00E9 voor é). UTF-8-bytes zijn hoe dat codepunt wordt opgeslagen — é is twee bytes, C3 A9.`)
};

const fr_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le point de code est le numéro du caractère dans la norme Unicode (par ex. U+00E9 pour é). Les octets UTF-8 sont la façon dont ce point de code est stocké — é est deux octets, C3 A9.`)
};

const it_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il punto di codice è il numero del carattere nello standard Unicode (ad esempio U+00E9 per é). I byte UTF-8 sono come quel punto di codice viene archiviato — é è due byte, C3 A9.`)
};

const pt_br2_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ponto de código é o número do caractere no padrão Unicode (por exemplo, U+00E9 para é). Bytes UTF-8 são como esse ponto de código é armazenado — é tem dois bytes, C3 A9.`)
};

const pt_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ponto de código é o número do carácter na norma Unicode (por exemplo, U+00E9 para é). Os bytes UTF-8 são como esse ponto de código é armazenado — é são dois bytes, C3 A9.`)
};

const ja_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「コードポイントは Unicode 標準における文字の番号です (例: é の U+00E9)。UTF-8 バイトはそのコードポイントがどのように保存されるかです。é は 2 バイト C3 A9 です。」`)
};

const zh_ci_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`码点是该字符在 Unicode 标准中的编号（例如 é 对应 U+00E9）。UTF-8 字节则是该码点的存储方式——é 是两个字节，C3 A9。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq2_a", locale)
	if (locale === "en") return en_ci_faq2_a(inputs)
	if (locale === "es") return es_ci_faq2_a(inputs)
	if (locale === "de") return de_ci_faq2_a(inputs)
	if (locale === "nl") return nl_ci_faq2_a(inputs)
	if (locale === "fr") return fr_ci_faq2_a(inputs)
	if (locale === "it") return it_ci_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq2_a(inputs)
	if (locale === "pt") return pt_ci_faq2_a(inputs)
	if (locale === "ja") return ja_ci_faq2_a(inputs)
	return zh_ci_faq2_a(inputs)
};